import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatAccordion } from "@angular/material/expansion";
import { DynamicHelpListComponent } from "app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component";
import { EMRService } from "app/EMR/EMR.service";
import { DiseaseModel } from "app/EMR/HistoryModels/disease.model";
import { AuthService } from "app/auth/auth.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { HelplistService } from "app/helplist.service";
import { Observable, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-dental-emr",
  templateUrl: "./Dental-Emr.component.html",
  styleUrls: ["./Dental-Emr.component.scss"],
})
export class DentalEmrComponent implements OnInit {
  destroypast$: Subject<boolean> = new Subject<boolean>();
  private pastHistoryArray=[];
  enabledisablebtn:boolean=false;
  private editCache: { [key: string]: any } = {};
  private EditId: any;
  private todaysdate = this.authService.getServerDate;
  private filteredOptions_diseases: Observable<DiseaseModel[]>;
  private DiseaseControl = new FormControl();
  @ViewChild(MatAccordion) accordion: MatAccordion;
  constructor(private emrservice: EMRService, private datePipe: DatePipe, private authService: AuthService,
    private dashboardService: DashboardService, private helplistservice: HelplistService,
    private dialog: MatDialog) {}
  ngOnInit(): void {
    this.pastHistoryArray=this.emrservice.pasthistory;
    this.updateEdit();
    this.filteredOptions_diseases = this.DiseaseControl.valueChanges
      .pipe(
        startWith(null),
        map(disease => disease ? this._filterdiseases(disease) : this.helplistservice.diseaseList.slice())
      );
  }
  private _filterdiseases(value: string): DiseaseModel[] {
    const filterValue = value.toLowerCase();
    return this.helplistservice.diseaseList.filter
      (disease => disease.diseaseName.toLowerCase().indexOf(filterValue) === 0);
  }
  
  // save systemic
  saveEdit(idx): void {
    const id = idx;
    let payloadarray = [];
    let editpayload;
    let startdate;
    let recoverydate;
    let editlist = this.editCache[id].data;
    if (editlist.startDate != null) {
      startdate = this.datePipe.transform(editlist.startDate, "yyyy-MM-dd").toString();
    }
    if (editlist.recoveryOn != null) {
      recoverydate = this.datePipe.transform(editlist.recoveryOn, "yyyy-MM-dd").toString();
    }
    payloadarray.push({
      "diseaseName": editlist.diseaseName,
      "startDate": startdate,
      "recoveryOn": recoverydate,
      "remarks": editlist.remarks,
      "pkTranId": editlist.pkTranId,
      "fkRegId": editlist.fkRegId,
      "pkSynchId": editlist.pkSynchId,
      "fkReg": editlist.fkReg
    });
    this.editCache[id].edit = false;
    editpayload = payloadarray;
    this.emrservice.save_pasthistory_to_server(editpayload).pipe(takeUntil(this.destroypast$)).subscribe(
      data => this.success_pasthistory_saved(data), err => this.failed_pasthistory_saved(err)
    )
  }
  success_pasthistory_saved(data) {
    this.dialog.closeAll();
    this.enabledisablebtn = true;
    this.emrservice.pasthistory = [];
   // this.emrservice.getHistoryStatus();
    this.get_pasthistory();
  
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
  }
  failed_pasthistory_saved(err) {
    this.dialog.closeAll();
    console.log("insert SystemicHistory api failed");
  }
  save_pasthistory(){

  }
  cancelEdit(idx): void {
    const id = idx;
    this.editCache[id].edit = false;
  }
  deletehistory(row) {
    if (this.emrservice.pasthistoryPermission?.isDeletePermission == true) {
      this.emrservice.open_loader_Dialog();
      if (row.pkTranId > 0) {
        this.emrservice.delete_pasthistory_on_server(row.pkTranId).pipe(takeUntil(this.destroypast$)).subscribe(
          data => this.success_delete_pasthistory(data), err => this.failed_delete_pasthistory(err)
        )
      } else {
        const index: number = this.pastHistoryArray.indexOf(row);
        if (index !== -1) {
          this.pastHistoryArray.splice(index, 1);
          this.pastHistoryArray = [...this.pastHistoryArray];
        }
        this.dialog.closeAll();
      }
    } else {
      this.dashboardService.openSnackBar("Delete permission denied", "OK");
    }
  }
  success_delete_pasthistory(data) {
    this.enabledisablebtn = true;
    this.dialog.closeAll();
    this.get_pasthistory();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.dashboardService.openSnackBar("Systemic history successfully deleted", "OK");
  }
  failed_delete_pasthistory(err) {
    this.dialog.closeAll();
  }
  get_pasthistory() {
    this.emrservice.get_pasthistory(this.emrservice.visitid).pipe(takeUntil(this.destroypast$)).subscribe(
      data => this.success_pasthostory(data), err => this.failed_pasthistory(err)
    )
  }

  success_pasthostory(data) {

    if (data.length > 0) {
     this.pastHistoryArray = [];
      var getPastHistorydata =[];
      data.forEach(item => {
        getPastHistorydata.push({
          "diseaseName": item.diseaseName,
          "startDate": item.startDate,
          "recoveryOn": item.recoveryOn,
          "remarks": item.remarks,
          "pkTranId": item.pkTranId,
          "fkRegId": item.fkRegId,
          "pkSynchId": item.pkSynchId,
          "fkReg": item.fkReg
        });
      });
      this.pastHistoryArray = getPastHistorydata;
    } else {
      this.pastHistoryArray = [];
    }
    this.updateEdit();
  }

  failed_pasthistory(err) {

  }
  getStartdateEdit(index): string {
    const id = index;
    return this.editCache[id].data.startDate;
  }
  updateEdit(): void {

    this.pastHistoryArray.forEach((item, index) => {
      const id = index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };
    });

  }

  Edit(index) {

    if (this.emrservice.pasthistoryPermission?.isModifyPermission == true) {
      const id = index;
      this.EditId = id;
      this.updateEdit();
      this.editCache[id].edit = true;
      console.log(this.editCache[id].data.diseaseName);
      if (this.editCache[id].data.startDate != "1900-01-01T00:00:00") {
        this.editCache[id].data.startDate = this.datePipe.transform(this.editCache[id].data.startDate, "yyyy-MM-dd").toString();

      } else {
        this.editCache[id].data.startDate = null;

      }
      if (this.editCache[id].data.recoveryOn != "1900-01-01T00:00:00") {

        this.editCache[id].data.recoveryOn = this.datePipe.transform(this.editCache[id].data.recoveryOn, "yyyy-MM-dd").toString();
      } else {

        this.editCache[id].data.recoveryOn = null;
      }


    } else {
      this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
  }
  
  refReasonPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroypast$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.editCache[this.EditId].data.remarks = result;
        }

      }
    });
  }
}
